import Constant from "./constant";
const commonReducer = (state = { ...Constant }, action) => {
  switch (action.type) {
    case "init":
      return { ...state };
    case "isLoggedIn":
      return { ...state, isLoggedIn: action.data };
    case "setLoading":
      return { ...state, loader: action.data };
    case 'showLoader':
      return { ...state, showLoader: action.data }
    case 'setLoaderData':
    return { ...state, loaderData: action.data }
    case "setUserToken":
      return { ...state, userToken: action.data };
    case "setSelectedMenue":
      return { ...state, selectedMenu: action.data };
    case 'SetLoginFormData':
      return { ...state, LoginFormData: action.data };
    case 'SetHomeData':
      return { ...state, HomeData: action.data };
    case 'SetQueryperam':
      return { ...state, Queryperam: action.data }
    case "GetClaimRecordsReport":
      return { ...state, GetClaimRecordsData: action.data };     
    case "setRedirectLoader":
      return { ...state, RedirectLoader: action.data };       
    default:
      return state;
  }
};
export default commonReducer;
